window.CKEDITOR.stylesSet.add('default', [])
